import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { defaultConfig } from "./default_config";
import { PivotControl } from "../../constants/pivot_control_options";
import { DatePivotParams } from "../../entities/date_pivot_params";
import { defaultChartViewerConfig } from "./default_chart_viewer_config";

export const InventoryNoPerspectiveContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "inventory_forecast_master",
        transformId: "inventory_forecast_master_date_pivot",
        folder: "outputs",
        title: "Inventory",
        dateHierarchyColumnFilter: {
          week: "week",
        },
        excludedSegmentationsFilter: [],
        measureColumnFilter: {
          quantity: "quantity",
          cost: "cost",
          pallets: "pallets",
          // Schema-gated like pallets: appears only for customers whose
          // inventory_forecast_master carries the column (currently Cora).
          eaches: "eaches",
        },
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DatePeriodPicker,
          PivotControl.FilterBy,
          PivotControl.Measure,
          PivotControl.SegmentSelectMulti,
          PivotControl.StoreAsDefault,
          PivotControl.Download,
          PivotControl.ShowSettings,
          PivotControl.EnableChartView,
        ],
        paramsToTransformArgs: (
          params: DatePivotParams
        ): Record<string, any> => {
          const transformArgs = {
            min_date: params.minDate,
            max_date: params.maxDate,
            date_field: params.dateHierarchy,
            value_field: params.measure,
            group_by_fields: params.segments || [],
            filters: params.filters || [],
          };
          return transformArgs;
        },
      }}
      defaultConfig={defaultConfig}
      chartConfig={defaultChartViewerConfig}
    />
  );
};
